import { CreateAdminInviteData } from '@models/AdminInvite'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Admin, CreateAdminData, UpdateAdminData } from '../models/Admin'
import {
  ADMIN_NOTIFICATIONS_URL,
  ADMINS_URL,
  REGISTER_URL,
} from '../utils/urls'

const fetchAdmins = (params: TableParams) =>
  SBAPI.FetchPaginated<Admin[]>(ADMINS_URL, params)

const fetchAdminById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<Admin>(`${ADMINS_URL}/${id}`, params)

const inviteAdmin = (data: CreateAdminInviteData) =>
  SBAPI.Post(`${ADMINS_URL}/invite`, data)

/**
 * Register an admin
 *
 * For this to work the email address must have been invited first
 *
 * Error codes:
 * - 404 auth.admins.no_invitation
 * - 422 auth.admins.admin_already_exists_with_this_email
 */
const registerAdmin = (data: CreateAdminData) => SBAPI.Post(REGISTER_URL, data)

const updateAdmin = (admin: UpdateAdminData) =>
  SBAPI.Put(`${ADMINS_URL}/${admin.id}`, admin)

const deleteAdmin = (admin: Admin) => SBAPI.Delete(`${ADMINS_URL}/${admin.id}`)

const sendNotificationPreview = (
  params:
    | { type: 'renewal-reminder' }
    | { type: 'birthday-reminder'; period: 'daily' | 'weekly' }
) => SBAPI.Post(`${ADMIN_NOTIFICATIONS_URL}/preview`, params)

export {
  deleteAdmin,
  fetchAdminById,
  fetchAdmins,
  inviteAdmin,
  registerAdmin,
  sendNotificationPreview,
  updateAdmin,
}
